// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__VNEL2","unreadBadge":"styles_unreadBadge__1wc2e","modalContent":"styles_modalContent__2a7uR","modal":"styles_modal__3NjXg"};